import * as React from 'react';
import { AppUser } from 'Src/views/App/App';
import Promise from 'bluebird';
import { Component } from 'react';
import { DATE_INTERVAL, FILTER_TYPE, FIRST_PAGE, LIMIT } from 'Src/consts/table';
import { History, Location } from 'history';
import { parse } from 'query-string';
import { SimpleModal } from 'Src/components/SimpleModal/SimpleModal';
import { SelectAllCheckbox } from 'Src/components/SelectAllCheckbox/SelectAllCheckbox';
import {
  ColumnDefinition,
  getFilters2,
  getOrder,
  getSearchFilter,
  getSearchOrder,
  getServerFieldSectionWhere,
  getServerQueryFilter2,
  isFilterExist2,
  isSortExist,
  TABLE_SORT_DIRECTION
} from 'Src/helpers/table/table';
import {
  getCoachEvent,
  getEventAges,
  getEventGender,
  getEventGeneratedName,
  getEventStartTime,
  getEventStatus,
  getEventSubtype,
  getEventType,
  getEventVenue,
  getEventVenueType,
  getStaffEvent
} from 'Src/helpers/accessor/accessor';
import { SchoolForm } from 'Src/models/form';
import { getAllForms } from 'Src/helpers/service/admin/forms';
import propz from 'propz';
import BPromise from 'bluebird';
import {
  getSelectOptionForAge,
  getSelectOptionForEventTypes,
  getSelectOptionForEventVenueType,
  getSelectOptionForSport,
  getSelectOptionForTournamentEventGender,
  getSelectOptionForTournamentEventStatus
} from 'Src/helpers/table/select';
import { SchoolEvent } from 'Src/models/event';
import { Sport } from 'Src/models/sport';
import { getEventNameWithLink } from 'Src/helpers/cell/cell';
import {
  getAllSchoolLeagueEvents,
  getSchoolLeague,
  getSchoolLeagueEvents,
  getSchoolLeagueEventsCount,
  removeEventToSchoolLeague
} from 'Src/helpers/service/admin/schoolLeagues';
import { SchoolLeague } from 'Src/models/schoolLeague';
import { Loader } from 'Src/components/Loader/Loader';
import './SchoolLeagueEvents.scss';

const COLUMNS: ColumnDefinition[] = [
  {
    text: 'Event',
    field: 'generatedName',
    isSort: false,
    type: FILTER_TYPE.NONE,
    cell: getEventNameWithLink
  },
  {
    text: 'Start time',
    field: 'startTime',
    isSort: true,
    type: FILTER_TYPE.DATE_INTERVAL,
    accessor: getEventStartTime
  },
  {
    text: 'Kind',
    field: 'eventType',
    isSort: false,
    type: FILTER_TYPE.MULTISELECT,
    accessor: getEventType
  },
  {
    text: 'Status',
    field: 'status',
    isSort: true,
    type: FILTER_TYPE.MULTISELECT,
    accessor: getEventStatus
  },
  {
    text: 'Sport',
    field: 'eventSport',
    isSort: false,
    type: FILTER_TYPE.MULTISELECT,
    accessor: ['sport', 'name']
  },
  {
    text: 'Age',
    field: 'eventAges',
    isSort: false,
    type: FILTER_TYPE.CHECKBOX,
    accessor: getEventAges
  },
  {
    text: 'Gender',
    field: 'gender',
    isSort: true,
    type: FILTER_TYPE.CHECKBOX,
    accessor: getEventGender
  },
  {
    text: 'Home/Away',
    field: 'venueType',
    isSort: true,
    type: FILTER_TYPE.MULTISELECT,
    accessor: getEventVenueType
  },
  {
    text: 'Venue',
    field: 'venue',
    isSort: false,
    type: FILTER_TYPE.NONE,
    accessor: getEventVenue
  },
  {
    text: 'Coach/Leader',
    field: 'coach',
    isSort: false,
    type: FILTER_TYPE.NONE,
    accessor: getCoachEvent
  },
  {
    text: 'Staff',
    field: 'staff',
    isSort: false,
    type: FILTER_TYPE.NONE,
    accessor: getStaffEvent
  },
  {
    text: 'Type',
    field: 'subtype',
    isSort: false,
    type: FILTER_TYPE.NONE,
    accessor: getEventSubtype
  }
];

interface State {
  items: SchoolEvent[];
  currentPage: number;
  selectedItems: SchoolEvent[];
  sortDirection: TABLE_SORT_DIRECTION;
  sortColumnsName: string;
  isShowFilter: boolean;
  filterOptions: any;
  currentTabIndex: number;
  isDataFiltered: boolean;
  filters: any;
  isLoading: boolean;
  isSelectAllChecked: boolean;
  total: number;
  basePath: string;
  isErrorModalOpen: boolean;
  errorMessage: string;
  isCancelEventToLeagueModalOpen: boolean;

  forms: SchoolForm[];
  sports: Sport[];
  league: SchoolLeague;
  isColumnsOpen: boolean;
  visibleColumns: {
    startTime: boolean;
    sport: boolean;
    venue: boolean;
    status: boolean;
  };
}

interface Props {
  user: AppUser;
  history: History;
  location: Location;
}

export class SchoolLeagueEvents extends Component<Props, State> {
  constructor(props) {
    super(props);

    const visibleColumns = this.loadVisibleColumns(props.user);

    this.state = {
      items: [],
      currentPage: FIRST_PAGE,
      selectedItems: [],
      sortDirection: '',
      sortColumnsName: '',
      isShowFilter: false,
      filterOptions: undefined,
      isDataFiltered: false,
      currentTabIndex: 0,
      filters: {},
      isLoading: false,
      isSelectAllChecked: false,
      total: 0,
      basePath: '',
      isErrorModalOpen: false,
      isCancelEventToLeagueModalOpen: false,
      errorMessage: '',
      forms: [],
      sports: [],
      league: undefined,
      isColumnsOpen: false,
      visibleColumns
    };
  }

  componentDidMount() {
    document.addEventListener('keydown', this.onDocumentKeyDown);
    window.dispatchEvent(new CustomEvent('sit:topbar-breadcrumb', { detail: 'School leagues / Events' }));
    this.setState({
      isLoading: true
    });
    this.setAdditionalItems().then(res => {
      this.setItems();
    });
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onDocumentKeyDown);
    window.dispatchEvent(new CustomEvent('sit:topbar-breadcrumb-clear'));
  }

  getColumnsStorageKey = (user: AppUser): string =>
    `columnVisibility__${propz.get(user, ['userId'], 'anonymous')}__school-league-events`;

  loadVisibleColumns = (user: AppUser): State['visibleColumns'] => {
    const defaults = { startTime: true, sport: true, venue: true, status: true };
    try {
      const saved = window.localStorage.getItem(this.getColumnsStorageKey(user));
      return saved ? { ...defaults, ...JSON.parse(saved) } : defaults;
    } catch (error) {
      return defaults;
    }
  };

  onDocumentKeyDown = (event: KeyboardEvent): void => {
    if (event.key === 'Escape') {
      if (this.state.isShowFilter) {
        this.onCancelFilterClick();
      } else {
        this.setState({ isColumnsOpen: false });
      }
    }
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.location.search !== this.props.location.search) {
      this.setState({
        isLoading: true
      });
      this.setItems();
    }
  }

  getLeagueId(): string {
    const { history } = this.props;
    const search = parse(history.location.search);
    const leagueId = search.league;
    return leagueId;
  }

  setAdditionalItems() {
    const { user } = this.props;
    const leagueId = this.getLeagueId();

    const formsPromise = getAllForms(user);
    const leagueEventsPromise = getAllSchoolLeagueEvents(user, leagueId);
    const leaguePromise = getSchoolLeague(user, leagueId);

    return Promise.all([formsPromise, leagueEventsPromise, leaguePromise]).then(([forms, leagueEvents, league]) => {
      const sportsById = {};
      leagueEvents.forEach(event => {
        const sport = propz.get(event, ['sport']);
        const sportId = propz.get(sport, ['id'], propz.get(sport, ['_id'], ''));
        if (sport && sportId) {
          sportsById[sportId] = sport;
        }
      });
      const sports = Object.keys(sportsById)
        .map(id => sportsById[id])
        .sort((sportA, sportB) => String(sportA.name).localeCompare(String(sportB.name)));
      const filterOptions = this.getFilterOptions(forms, sports);
      window.dispatchEvent(
        new CustomEvent('sit:topbar-breadcrumb', { detail: `School leagues / ${league.name} / Events` })
      );
      this.setState({
        forms: forms,
        sports: sports,
        league: league,
        filterOptions: filterOptions
      });

      return true;
    });
  }

  setItems() {
    const { history, user } = this.props;

    const search = parse(history.location.search);
    const page = typeof search.page !== 'undefined' ? Number(search.page) : FIRST_PAGE;

    let sortDirection = '';
    let sortColumnsName = '';

    if (typeof search.order === 'string') {
      [sortColumnsName, sortDirection] = search.order.split(':');
    }

    const sortByFieldExist = sortColumnsName !== '';
    const sortDirectionExist = sortDirection !== '';

    const filters = getFilters2(COLUMNS, search);

    const isDataFiltered = isFilterExist2(filters);

    const where = getServerFieldSectionWhere(filters, { isCorrectTime: true });

    const order = sortByFieldExist && sortDirectionExist ? `${sortColumnsName} ${sortDirection}` : undefined;
    const serverQueryFilter = getServerQueryFilter2(page, where, order);
    const leagueId = this.getLeagueId();

    const getItemsPromise = getSchoolLeagueEvents(user, leagueId, serverQueryFilter);
    const getItemsCountPromise = getSchoolLeagueEventsCount(user, leagueId, where);

    return Promise.all([getItemsCountPromise, getItemsPromise]).then(([countObj, items]) => {
      this.setState({
        currentPage: page,
        sortDirection: sortDirection as TABLE_SORT_DIRECTION,
        sortColumnsName: sortColumnsName,
        isShowFilter: false,
        isDataFiltered: isDataFiltered,
        filters: filters,
        items: items,
        total: countObj.count,
        basePath: history.location.pathname,
        isLoading: false
      });

      return true;
    });
  }

  setCurrentPageParams = (currentPage: number): void => {
    let search: string[] = [];

    const { filters, sortColumnsName, sortDirection } = this.state;

    if (currentPage !== 1) {
      search.push(`page=${currentPage}`);
    }

    if (isSortExist(sortDirection, sortColumnsName)) {
      search.push(getSearchOrder(sortDirection, sortColumnsName));
    }

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    const leagueId = this.getLeagueId();

    this.props.history.push({
      pathname: this.state.basePath,
      search: `league=${leagueId}&${search.join('&')}`
    });
  };

  onItemClick = (index: number): void => {
    const { items, selectedItems } = this.state;
    const selectedItem = items[index];

    const selectedItemIndex = selectedItems.findIndex(item => selectedItem.id === item.id);
    let selectedItemsUpdated = [...selectedItems];

    if (selectedItemIndex !== -1) {
      selectedItemsUpdated.splice(selectedItemIndex, 1);
    } else {
      selectedItemsUpdated.push(selectedItem);
    }

    this.setState({
      selectedItems: selectedItemsUpdated,
      currentTabIndex: 0
    });
  };

  onSelectAllOnPageClick = (): void => {
    const { items, selectedItems } = this.state;

    const itemsFiltered = items.filter(item => {
      return selectedItems.every(selectedItem => selectedItem.id !== item.id);
    });

    const selectedItemsNext = [...selectedItems, ...itemsFiltered];

    this.setState({
      selectedItems: selectedItemsNext,
      isSelectAllChecked: true
    });
  };

  onSelectAllClick = (): void => {
    const { selectedItems, filters } = this.state;

    this.setState({
      isLoading: true
    });

    const user = this.props.user;

    const where = getServerFieldSectionWhere(filters);
    const leagueId = this.getLeagueId();

    getAllSchoolLeagueEvents(user, leagueId, where).then(items => {
      const itemsFiltered = items.filter(item => {
        return selectedItems.every(selectedItem => selectedItem.id !== item.id);
      });

      const selectedItemsNext = [...selectedItems, ...itemsFiltered];

      this.setState({
        selectedItems: selectedItemsNext,
        isSelectAllChecked: true,
        isLoading: false
      });
    });
  };

  onUnselectAllClick = (): void => {
    this.setState({
      selectedItems: [],
      isSelectAllChecked: false,
      isShowFilter: false
    });
  };

  onTableSortClick = (sortField: string): void => {
    const { sortDirection, sortColumnsName, filters } = this.state;

    const order = getOrder(sortField, sortDirection, sortColumnsName);

    let search: string[] = [];
    search.push(`order=${sortField}:${order}`);

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    const leagueId = this.getLeagueId();

    this.props.history.push({
      pathname: this.state.basePath,
      search: `league=${leagueId}&${search.join('&')}`
    });
  };

  onTableFilterChange = (event, filterField: string, options?, index?: number, checkBoxIndex?: number): void => {
    const filterValue = propz.get(event, ['target', 'value'], '');
    const { filters, filterOptions } = this.state;
    const currentFilterField = filters[filterField];
    let nextFilters = { ...filters };

    if (typeof options !== 'undefined') {
      switch (options) {
        case DATE_INTERVAL.FROM:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              from: filterValue
            }
          };
          break;
        case DATE_INTERVAL.TO:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              to: filterValue
            }
          };
          break;
      }
    } else {
      const filter = COLUMNS.find(col => col.field === filterField);
      const filterType = filter.type;

      switch (filterType) {
        case FILTER_TYPE.MULTISELECT:
          const options = event.target.options;

          const value = [];
          for (let i = 0; i < options.length; i++) {
            if (options[i].selected) {
              value.push(options[i].value);
            }
          }
          nextFilters = {
            ...nextFilters,
            [filterField]: value
          };
          break;
        case FILTER_TYPE.CHECKBOX:
          const columns = COLUMNS;
          const currentField = columns[index].field;
          filterOptions[currentField][checkBoxIndex].isChecked = !filterOptions[currentField][checkBoxIndex].isChecked;

          this.setState({
            filterOptions: filterOptions
          });

          const checkBoxValue = [];
          if (typeof filterOptions[filterField] !== 'undefined') {
            for (let i = 0; i < filterOptions[filterField].length; i++) {
              if (filterOptions[filterField][i].isChecked) {
                checkBoxValue.push(filterOptions[filterField][i].value);
              }
            }
          }
          nextFilters = {
            ...nextFilters,
            [filterField]: checkBoxValue
          };
          break;
        default:
          nextFilters = {
            ...nextFilters,
            [filterField]: filterValue
          };
          break;
      }
    }

    this.setState({
      filters: nextFilters
    });
  };

  onApplyFilterClick = (): void => {
    const { filters, sortDirection, sortColumnsName } = this.state;
    let search: string[] = [];

    if (isSortExist(sortDirection, sortColumnsName)) {
      search.push(getSearchOrder(sortDirection, sortColumnsName));
    }

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    this.setState({
      selectedItems: [],
      isSelectAllChecked: false,
      isShowFilter: false
    });

    const leagueId = this.getLeagueId();

    this.props.history.push({
      pathname: this.state.basePath,
      search: `league=${leagueId}&${search.join('&')}`
    });
  };

  onClearFilterClick = (): void => {
    const { forms, sports } = this.state;
    const filterOptions = this.getFilterOptions(forms, sports);

    this.setState({
      filterOptions: filterOptions,
      selectedItems: [],
      isSelectAllChecked: false,
      isShowFilter: false,
      filters: getFilters2(COLUMNS, {})
    });

    const leagueId = this.getLeagueId();

    this.props.history.push({
      pathname: this.state.basePath,
      search: `league=${leagueId}`
    });
  };

  onTableFilterClick = (event): void => {
    event.preventDefault();

    const isShowFilter = this.state.isShowFilter;

    this.setState({
      isShowFilter: !isShowFilter
    });
  };

  onCancelFilterClick = (): void => {
    const search = parse(this.props.history.location.search);
    this.setState({
      filters: getFilters2(COLUMNS, search),
      isShowFilter: false
    });
  };

  clearFilterField = (field: string): void => {
    this.setState(
      state => ({
        filters: {
          ...state.filters,
          [field]: []
        }
      }),
      this.onApplyFilterClick
    );
  };

  toggleColumn = (column: 'startTime' | 'sport' | 'venue' | 'status'): void => {
    this.setState(
      state => ({
        visibleColumns: {
          ...state.visibleColumns,
          [column]: !state.visibleColumns[column]
        }
      }),
      () => {
        try {
          window.localStorage.setItem(
            this.getColumnsStorageKey(this.props.user),
            JSON.stringify(this.state.visibleColumns)
          );
        } catch (error) {
          // Storage can be unavailable in privacy mode; the list remains usable.
        }
      }
    );
  };

  onCloseErrorClick = () => {
    this.setState({
      isErrorModalOpen: false,
      errorMessage: ''
    });
  };

  renderSendingError(): React.ReactNode {
    const { errorMessage, isErrorModalOpen } = this.state;

    return (
      <SimpleModal
        isOpen={isErrorModalOpen}
        title={'Error'}
        body={errorMessage}
        buttonCancelText={'Ok'}
        onCloseClick={this.onCloseErrorClick}
      />
    );
  }

  onShowError = (message: string) => {
    this.setState({
      isErrorModalOpen: true,
      errorMessage: message
    });
  };

  cancelEventToLeagueModalOpen = () => {
    this.setState({
      isCancelEventToLeagueModalOpen: true
    });
  };

  onCancelEventToLeagueClick = () => {
    const { user } = this.props;
    const selectedItems = this.state.selectedItems;
    this.setState({
      isLoading: true
    });

    BPromise.all(
      selectedItems.map(selectedItem => {
        const eventId = selectedItem.id;
        const leagueId = this.getLeagueId();
        const data = {
          eventId: eventId
        };

        return removeEventToSchoolLeague(user, leagueId, data);
      })
    ).then(items => {
      this.setState({
        isCancelEventToLeagueModalOpen: false
      });
      this.setItems();
    });
  };

  cancelEventToLeagueModalClose = (): void => {
    this.setState({
      isCancelEventToLeagueModalOpen: false
    });
  };

  renderCancelEventModal() {
    const { selectedItems, isCancelEventToLeagueModalOpen } = this.state;
    const { user } = this.props;
    const eventName = selectedItems.length > 0 ? getEventGeneratedName(selectedItems[0], { user: user }) : '';

    return (
      <SimpleModal
        isOpen={isCancelEventToLeagueModalOpen}
        title={'Remove Event'}
        body={`Are you sure you want to remove ${
          selectedItems.length === 1 ? `Event ${eventName}` : `${selectedItems.length} Events`
        }?`}
        buttonText={'Ok'}
        onButtonClick={this.onCancelEventToLeagueClick}
        onCloseClick={this.cancelEventToLeagueModalClose}
      />
    );
  }

  getFilterOptions = (forms, sports) => {
    const user = this.props.user;
    const activeSchool = user.activeSchool;
    const ageGroupsNaming = activeSchool.ageGroupsNaming;

    return {
      venueType: getSelectOptionForEventVenueType(),
      eventAges: getSelectOptionForAge(forms, ageGroupsNaming),
      gender: getSelectOptionForTournamentEventGender(),
      status: getSelectOptionForTournamentEventStatus(),
      eventType: getSelectOptionForEventTypes(),
      eventSport: getSelectOptionForSport(sports)
    };
  };

  goBack = () => {
    this.props.history.push({
      pathname: '/leagues'
    });
  };

  render() {
    const {
      items,
      sortDirection,
      sortColumnsName,
      isShowFilter,
      isDataFiltered,
      selectedItems,
      filters,
      isSelectAllChecked,
      currentPage,
      total,
      filterOptions,
      league,
      isErrorModalOpen,
      isCancelEventToLeagueModalOpen,
      isLoading,
      isColumnsOpen,
      visibleColumns
    } = this.state;

    const { user } = this.props;

    if (isLoading) {
      return <Loader />;
    }

    const classes =
      isErrorModalOpen || isCancelEventToLeagueModalOpen ? 'schoolLeaguesRoute modal-open' : 'schoolLeaguesRoute';
    const sportFilter = (filters.eventSport || [])[0] || '';
    const statusFilter = (filters.status || [])[0] || '';
    const pageCount = Math.max(1, Math.ceil(total / LIMIT));
    const firstResult = total === 0 ? 0 : (currentPage - 1) * LIMIT + 1;
    const lastResult = Math.min(currentPage * LIMIT, total);
    const pageNumbers: number[] = [];
    const pageStart = Math.max(1, Math.min(currentPage - 1, pageCount - 2));
    const pageEnd = Math.min(pageCount, pageStart + 2);
    for (let pageNumber = pageStart; pageNumber <= pageEnd; pageNumber++) {
      pageNumbers.push(pageNumber);
    }

    return (
      <div className={classes}>
        {/*Place for render modal windows*/}
        {this.renderCancelEventModal()}
        {this.renderSendingError()}
        <div className="leagueEventsPage">
          <header>
            <div>
              <button className="leagueEventsPage__back" onClick={this.goBack}>
                ← School leagues
              </button>
              <h1>{league ? league.name : 'League'} events</h1>
              <p>
                {total} {total === 1 ? 'event' : 'events'}
              </p>
            </div>
            <div className="leagueEventsPage__headerActions">
              <div className="leagueEventsPage__filterControl">
                {isShowFilter && (
                  <button
                    type="button"
                    className="leagueEventsPage__popoverScrim"
                    onClick={this.onCancelFilterClick}
                    aria-label="Dismiss filters"
                  />
                )}
                <button
                  className={`leagueEventsButton ${isShowFilter ? 'is-active' : ''}`}
                  onClick={event => {
                    this.setState({ isColumnsOpen: false });
                    this.onTableFilterClick(event);
                  }}
                  aria-expanded={isShowFilter}
                >
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M4 6h16M7 12h10M10 18h4" />
                  </svg>
                  Filters
                  {isDataFiltered && <i />}
                </button>
                {isShowFilter && (
                  <div
                    className="leagueEventsPage__filterPopover"
                    onKeyDown={event => {
                      const target = event.target as HTMLElement;
                      if (event.key === 'Enter' && (target.tagName === 'INPUT' || target.tagName === 'SELECT')) {
                        event.preventDefault();
                        this.onApplyFilterClick();
                      }
                    }}
                  >
                    <header>
                      <strong>Filters</strong>
                      <button type="button" onClick={this.onCancelFilterClick} aria-label="Close filters">
                        ×
                      </button>
                    </header>
                    <div className="leagueEventsPage__filterFields">
                      <label>
                        <span>Sport</span>
                        <span className="leagueEventsPage__select">
                          <select
                            value={sportFilter}
                            onChange={event => this.onTableFilterChange(event, 'eventSport')}
                            autoFocus={true}
                          >
                            <option value="">All sports</option>
                            {((filterOptions && filterOptions.eventSport) || []).map(option => (
                              <option key={option.value} value={option.value}>
                                {option.text}
                              </option>
                            ))}
                          </select>
                        </span>
                      </label>
                      <label>
                        <span>Status</span>
                        <span className="leagueEventsPage__select">
                          <select value={statusFilter} onChange={event => this.onTableFilterChange(event, 'status')}>
                            <option value="">All statuses</option>
                            {((filterOptions && filterOptions.status) || []).map(option => (
                              <option key={option.value} value={option.value}>
                                {option.text}
                              </option>
                            ))}
                          </select>
                        </span>
                      </label>
                    </div>
                    <footer>
                      <button type="button" className="is-clear" onClick={this.onClearFilterClick}>
                        Clear all
                      </button>
                      <div>
                        <button type="button" onClick={this.onCancelFilterClick}>
                          Cancel
                        </button>
                        <button type="button" className="is-apply" onClick={this.onApplyFilterClick}>
                          Apply
                        </button>
                      </div>
                    </footer>
                  </div>
                )}
              </div>
              <div className="leagueEventsPage__columnsControl">
                {isColumnsOpen && (
                  <button
                    type="button"
                    className="leagueEventsPage__popoverScrim"
                    onClick={() => this.setState({ isColumnsOpen: false })}
                    aria-label="Close column settings"
                  />
                )}
                <button
                  type="button"
                  className="leagueEventsButton"
                  onClick={() => this.setState({ isColumnsOpen: !isColumnsOpen, isShowFilter: false })}
                  aria-expanded={isColumnsOpen}
                >
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <rect x="4" y="5" width="16" height="14" rx="2" />
                    <path d="M10 5v14M15 5v14" />
                  </svg>
                  Columns
                </button>
                {isColumnsOpen && (
                  <div className="leagueEventsPage__columnsMenu">
                    <header>Show columns</header>
                    <label>
                      <input type="checkbox" checked={true} disabled={true} />
                      <span>Event</span>
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        checked={visibleColumns.startTime}
                        onChange={() => this.toggleColumn('startTime')}
                      />
                      <span>Date & time</span>
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        checked={visibleColumns.sport}
                        onChange={() => this.toggleColumn('sport')}
                      />
                      <span>Sport</span>
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        checked={visibleColumns.venue}
                        onChange={() => this.toggleColumn('venue')}
                      />
                      <span>Venue</span>
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        checked={visibleColumns.status}
                        onChange={() => this.toggleColumn('status')}
                      />
                      <span>Status</span>
                    </label>
                  </div>
                )}
              </div>
              <button
                className="leagueEventsButton leagueEventsButton--primary"
                onClick={() =>
                  this.props.history.push({
                    pathname: '/leagues/eligibleEvents',
                    search: `league=${this.getLeagueId()}`
                  })
                }
              >
                ＋ Add events
              </button>
            </div>
          </header>
          {isDataFiltered && (
            <div className="leagueEventsPage__chips">
              {sportFilter && (
                <button type="button" onClick={() => this.clearFilterField('eventSport')}>
                  Sport:{' '}
                  {((filterOptions && filterOptions.eventSport) || []).find(item => item.value === sportFilter)?.text ||
                    sportFilter}{' '}
                  <span>×</span>
                </button>
              )}
              {statusFilter && (
                <button type="button" onClick={() => this.clearFilterField('status')}>
                  Status:{' '}
                  {((filterOptions && filterOptions.status) || []).find(item => item.value === statusFilter)?.text ||
                    statusFilter}{' '}
                  <span>×</span>
                </button>
              )}
              <button type="button" className="is-clear" onClick={this.onClearFilterClick}>
                Clear all
              </button>
            </div>
          )}
          {selectedItems.length > 0 && (
            <div className="leagueEventsPage__selection">
              <span>{selectedItems.length} selected</span>
              <div>
                <button className="is-danger" onClick={this.cancelEventToLeagueModalOpen}>
                  Remove from league
                </button>
                <button onClick={this.onUnselectAllClick}>Clear</button>
              </div>
            </div>
          )}
          <section className="leagueEventsPage__card">
            <div className="leagueEventsPage__scroll">
              <table>
                <thead>
                  <tr>
                    <th>
                      <SelectAllCheckbox
                        compact
                        isChecked={
                          isSelectAllChecked ||
                          (items.length > 0 && items.every(item => selectedItems.some(selected => selected.id === item.id)))
                        }
                        totalCount={total}
                        currentPage={currentPage}
                        pageItemsCount={items.length}
                        selectedItems={selectedItems}
                        onSelectAllOnPageClick={this.onSelectAllOnPageClick}
                        onSelectAllClick={this.onSelectAllClick}
                        onUnselectAllClick={this.onUnselectAllClick}
                      />
                    </th>
                    <th>Event</th>
                    {visibleColumns.startTime && (
                      <th>
                        <button onClick={() => this.onTableSortClick('startTime')}>Date & time</button>
                      </th>
                    )}
                    {visibleColumns.sport && <th>Sport</th>}
                    {visibleColumns.venue && <th>Venue</th>}
                    {visibleColumns.status && <th>Status</th>}
                  </tr>
                </thead>
                <tbody>
                  {items.map((eventItem, index) => {
                    const isSelected = selectedItems.some(item => item.id === eventItem.id);
                    return (
                      <tr
                        key={eventItem.id}
                        className={isSelected ? 'is-selected' : ''}
                        onClick={() => this.onItemClick(index)}
                      >
                        <td>
                          <input
                            type="checkbox"
                            checked={isSelected}
                            onChange={() => this.onItemClick(index)}
                            onClick={clickEvent => clickEvent.stopPropagation()}
                          />
                        </td>
                        <td>
                          <div className="leagueEventsPage__event">
                            <i>
                              <svg viewBox="0 0 24 24">
                                <path d="M7 3v3M17 3v3M4 9h16M5 5h14a1 1 0 0 1 1 1v14H4V6a1 1 0 0 1 1-1Z" />
                              </svg>
                            </i>
                            <div>
                              <strong>{getEventGeneratedName(eventItem, { user })}</strong>
                              <small>
                                {getEventType(eventItem)} · {getEventGender(eventItem)}
                              </small>
                            </div>
                          </div>
                        </td>
                        {visibleColumns.startTime && <td>{getEventStartTime(eventItem)}</td>}
                        {visibleColumns.sport && <td>{propz.get(eventItem, ['sport', 'name'], '—')}</td>}
                        {visibleColumns.venue && <td>{getEventVenue(eventItem) || '—'}</td>}
                        {visibleColumns.status && (
                          <td>
                            <span
                              className={`leagueEventsPage__status is-${String(eventItem.status || '').toLowerCase()}`}
                            >
                              {getEventStatus(eventItem)}
                            </span>
                          </td>
                        )}
                      </tr>
                    );
                  })}
                  {!items.length && (
                    <tr>
                      <td
                        colSpan={
                          2 +
                          Number(visibleColumns.startTime) +
                          Number(visibleColumns.sport) +
                          Number(visibleColumns.venue) +
                          Number(visibleColumns.status)
                        }
                        className="leagueEventsPage__empty"
                      >
                        No events have been added to this league.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </section>
          {total > 0 && (
            <nav className="leagueEventsPage__pagination">
              <span className="leagueEventsPage__paginationInfo">
                Showing {firstResult}–{lastResult} of {total}
              </span>
              <div>
                <button disabled={currentPage <= 1} onClick={() => this.setCurrentPageParams(currentPage - 1)}>
                  ‹
                </button>
                {pageStart > 1 && (
                  <>
                    <button onClick={() => this.setCurrentPageParams(1)}>1</button>
                    {pageStart > 2 && <span>…</span>}
                  </>
                )}
                {pageNumbers.map(pageNumber => (
                  <button
                    key={pageNumber}
                    className={pageNumber === currentPage ? 'is-active' : ''}
                    onClick={() => this.setCurrentPageParams(pageNumber)}
                  >
                    {pageNumber}
                  </button>
                ))}
                {pageEnd < pageCount && (
                  <>
                    {pageEnd < pageCount - 1 && <span>…</span>}
                    <button onClick={() => this.setCurrentPageParams(pageCount)}>{pageCount}</button>
                  </>
                )}
                <button disabled={currentPage >= pageCount} onClick={() => this.setCurrentPageParams(currentPage + 1)}>
                  ›
                </button>
              </div>
            </nav>
          )}
        </div>
      </div>
    );
  }
}
